/**
 * Cart extras: reservation countdown timer.
 * <cart-reservation-timer data-duration="300" data-text="Reserved for [timer]">
 * <cart-reservation-timer data-empty> (rendered when the cart is empty) clears the stored timer.
 */
const STORAGE_KEY = 'cartReservationEnd';

/** @param {number} seconds */
function format(seconds) {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

function readEnd() {
  try {
    return Number(sessionStorage.getItem(STORAGE_KEY)) || 0;
  } catch (_e) {
    return 0;
  }
}

/** @param {number | null} value */
function writeEnd(value) {
  try {
    if (value === null) sessionStorage.removeItem(STORAGE_KEY);
    else sessionStorage.setItem(STORAGE_KEY, String(value));
  } catch (_e) {
    /* storage unavailable */
  }
}

class CartReservationTimer extends HTMLElement {
  /** @type {number | undefined} */
  #interval;

  connectedCallback() {
    if (this.hasAttribute('data-empty')) {
      writeEnd(null);
      return;
    }

    const duration = Math.max(10, Number(this.dataset.duration) || 300);
    let end = readEnd();
    if (!end || end <= Date.now()) {
      end = Date.now() + duration * 1000;
      writeEnd(end);
    }
    this.#end = end;
    this.#duration = duration;
    this.#render();
    this.#interval = window.setInterval(() => this.#render(), 1000);
  }

  disconnectedCallback() {
    if (this.#interval) window.clearInterval(this.#interval);
  }

  #end = 0;
  #duration = 300;

  #render() {
    let remaining = Math.round((this.#end - Date.now()) / 1000);
    if (remaining <= 0) {
      // Restart the reservation while items are still in the cart.
      this.#end = Date.now() + this.#duration * 1000;
      writeEnd(this.#end);
      remaining = this.#duration;
    }
    const target = this.querySelector('[data-cart-timer-text]');
    if (!target) return;
    const template = this.dataset.text || '[timer]';
    const timerHtml = `<span class="cart-timer__time">${format(remaining)}</span>`;
    target.innerHTML = template.replace('[timer]', timerHtml);
  }
}

if (!customElements.get('cart-reservation-timer')) {
  customElements.define('cart-reservation-timer', CartReservationTimer);
}
